import axios from "axios";
import path from "../../path";

// Create an Axios instance with default headers
const apiClient = axios.create({
  baseURL: path,
  headers: {
    "Content-Type": "application/json",
  },
});

// Helper function to get the auth token
const getAuthToken = () => sessionStorage.getItem("token");

// Add request interceptor to include token in headers
apiClient.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const doctorListApi = (headers) => {
  return axios.get(`${path}/v1/admin/doctors`, headers);
};

export const doctorDetailsApi = (id, headers) => {
  return axios.get(`${path}/v1/admin/doctor-info/${id}`, headers);
};

export const providerDetailsApi = (id, headers) => {
  return axios.get(`${path}/v1/admin/provider-info/${id}`, headers);
};

export const updateDoctorPrimaryStatus = (doctorId, headers) => {
  return axios.put(
    `${path}/v1/admin/update-primary-status/${doctorId}`,
    {},
    headers
  );
};

export const getTeamsInfoApi = async (
  id,
  page,
  rowsPerPage,
  orderBy,
  order,
  search
) => {
  try {
    const response = await apiClient.get(`/v1/admin/teams-info/${id}`, {
      params: {
        page: page + 1,
        limit: rowsPerPage,
        sortBy: orderBy,
        order: order,
        search: search,
      },
    });
    return response;
  } catch (error) {
    console.error("Error fetching leads:", error);
    throw error;
  }
};

export const getProvidersApi = async (
  page,
  rowsPerPage,
  orderBy,
  order,
  search
) => {
  try {
    const response = await apiClient.get(`/v1/admin/providers`, {
      params: {
        page: page + 1,
        limit: rowsPerPage,
        sortBy: orderBy,
        order: order,
        search: search,
      },
    });
    return response;
  } catch (error) {
    console.error("Error fetching leads:", error);
    throw error;
  }
};

export const getArchivedProvidersApi = async (
  page,
  rowsPerPage,
  orderBy,
  order,
  search
) => {
  try {
    const response = await apiClient.get(`/v1/admin/archived-providers`, {
      params: {
        page: page + 1,
        limit: rowsPerPage,
        sortBy: orderBy,
        order: order,
        search: search,
      },
    });
    return response;
  } catch (error) {
    console.error("Error fetching leads:", error);
    throw error;
  }
};

export const getAllReviewsApi = async (
  page,
  rowsPerPage,
  orderBy,
  order,
  search,
  providerId
) => {
  try {
    const response = await apiClient.get(`/v1/admin/get-all-reviews`, {
      params: {
        page: page + 1,
        limit: rowsPerPage,
        sortBy: orderBy,
        order: order,
        search: search,
        providerId,
      },
    });
    return response;
  } catch (error) {
    console.error("Error fetching leads:", error);
    throw error;
  }
};

export const deleteDoctorApi = (doctorID, headers) => {
  return axios.put(`${path}/v1/admin/delete-doctor/${doctorID}`, headers);
};

export const createDoctorApi = (data, headers) => {
  return axios.post(`${path}/v1/doctors/signup`, { data }, headers);
};

export const addReviewApi = (data, headers) => {
  return axios.post(`${path}/v1/admin/review`, { data }, headers);
};

export const inviteProviderApi = (data, headers) => {
  return axios.post(`${path}/v1/admin/invite-provider`, { data }, headers);
};

export const LeadsApi = (headers) => {
  return axios.get(`${path}/v1/admin/lead-list`, headers);
};

export const editProviderApi = (data, providerId, headers) => {
  return axios.put(
    `${path}/v1/admin/edit-provider-info/${providerId}`,
    { data },
    headers
  );
};

export const addDoctorApi = (data, providerId, headers) => {
  return axios.post(
    `${path}/v1/admin/add-doctor/${providerId}`,
    { data },
    headers
  );
};

// export const addTeamApi = (data, providerId, headers) => {
//     return axios.post(`${path}/v1/admin/add-team/${providerId}`, { data } ,headers);
//   };

export const addTeamApi = async (id, data) => {
  try {
    const response = await apiClient.post(`/v1/admin/add-team/${id}`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    console.error("Error updating profile:", error);
    throw error;
  }
};

export const importReviewApi = async (data) => {
  try {
    const response = await apiClient.post(`/v1/admin/csv-review`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    console.error("Error updating profile:", error);
    throw error;
  }
};

export const updateDoctorApi = (doctorId, data, headers) => {
  return axios.put(
    `${path}/v1/admin/edit-doctor/${doctorId}`,
    { data },
    headers
  );
};

export const getDoctorApi = (doctorId, headers) => {
  return axios.get(`${path}/v1/admin/doctor-staff-info/${doctorId}`, headers);
};

export const resendInviteProviderApi = (data, headers) => {
  return axios.post(
    `${path}/v1/admin/resend-invite-provider`,
    { data },
    headers
  );
};

export const getAllLeadsAPI = async (
  page,
  rowsPerPage,
  orderBy,
  order,
  activeTab,
  search,
  id,
) => {
  try {
    const response = await apiClient.get(`/v1/admin/get-all-leads`, {
      params: {
        page: page + 1,
        limit: rowsPerPage,
        sortBy: orderBy,
        order: order,
        filter: activeTab,
        search: search,
        id,
      },
    });
    return response;
  } catch (error) {
    console.error("Error fetching leads:", error);
    throw error;
  }
};

export const changeProviderApi = (leadId, data, headers) => {
  return axios.put(
    `${path}/v1/admin/change-provider/${leadId}`,
    { data },
    headers
  );
};

export const getAllActiveProviderApi = (headers) => {
  return axios.get(`${path}/v1/admin/get-all-active-provider`, headers);
};

export const generateCSVFile = (data) => {
  return apiClient.get(`/v1/lead/csv-export`, {
    params: {
      data,
    },
  });
};

export const resendTeamMail = (id, headers) => {
  return axios.get(`${path}/v1/admin/resend-mail/${id}`, headers);
};

export const updateWebhookUrl = (data) => {
  return apiClient.put(`${path}/v1/url/create-tiny-url`, data);
};

export const getWebhookUrl = (id) => {
  return apiClient.get(`${path}/v1/url/get-url/${id}`);
};
export const getLeadCounts = async (providerId, timeRange) => {
  try {
    const response = await apiClient.get(`/v1/admin/lead-count`, {
      params: {
        providerId: providerId,
        timeRange: timeRange,
      },
    });
    return response;
  } catch (error) {
    console.error("Error fetching leads:", error);
    throw error;
  }
};

export const getAllTeamsApi = async (
  page,
  rowsPerPage,
  orderBy,
  order,
  search
) => {
  try {
    const response = await apiClient.get(`/v1/admin/all-teams`, {
      params: {
        page: page + 1,
        limit: rowsPerPage,
        sortBy: orderBy,
        order: order,
        search: search,
      },
    });
    return response;
  } catch (error) {
    console.error("Error fetching all teams:", error);
    throw error;
  }
};

export const editTeamMemberApi = async (id, data) => {
  try {
    const response = await apiClient.put(
      `/v1/admin/edit-team-member/${id}`,
      data,
    );
    return response;
  } catch (error) {
    console.error("Error editing team member:", error);
    throw error;
  }
};

export const updateLocationTagApi = async (providerId, data) => {
  try {
    const response = await apiClient.put(
      `/v1/admin/location-tag/${providerId}`,
       data,
    );
    return response;
  } catch (error) {
    throw error.response?.data || "Something went wrong";
  }
};



export const deleteTeamMemberApi = async (id) => {
  try {
    const response = await apiClient.delete(`/v1/admin/delete-team-member/${id}`);
    return response;
  } catch (error) {
    console.error("Error deleting team member:", error);
    throw error;
  }
};

